module.exports = __webpack_public_path__ + "media/images/proof_links/shopify-979eae1c32c1c33ed342149b2876347f.svg";